export default __webpack_public_path__ + "static/media-kit-535685b35ab774df2a7b3d138895d1b0.webp";